
import React from 'react'

export function LandFreightRateDetails() {

    return (

        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-12">
                                <hr />
                            </div>
                            <div className="col-md-12">
                                <div className="card p-3">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 border-end">
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Origin City - </td>
                                                        <td className="py-1">Indore</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Destination City - </td>
                                                        <td className="py-1">New York</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Origin Country - </td>
                                                        <td className="py-1">India</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Destination Country - </td>
                                                        <td className="py-1">USA</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Door Delivery - </td>
                                                        <td className="py-1">15.30</td>
                                                    </tr>



                                                    <tr>
                                                        <td className="py-1">Port Delivery - </td>
                                                        <td className="py-1">17</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Fuel - </td>
                                                        <td className="py-1">200</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Normal Amount - </td>
                                                        <td className="py-1">659 AED</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Minimum Amount - </td>
                                                        <td className="py-1">659 AED</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div >
                </div >
            </div >
        </div >
    )
}
